import { store } from '@shared/redux/store';
import { StrictMode, useContext, useMemo } from 'react';
import { Provider as ReduxProvider, ReactReduxContext } from 'react-redux';
import { createBrowserRouter, RouterProvider, useInRouterContext } from 'react-router-dom';

const WithRouter = ({
    routes,
    routeOpts
}: {
    routes: Parameters<typeof createBrowserRouter>[0];
    routeOpts?: Parameters<typeof createBrowserRouter>[1];
}) => {
    const router = createBrowserRouter(routes, routeOpts);
    return <RouterProvider router={router} />;
};

export const App = ({
    children,
    routes,
    routeOpts
}: React.PropsWithChildren<{
    routes?: Parameters<typeof createBrowserRouter>[0];
    routeOpts?: Parameters<typeof createBrowserRouter>[1];
}>) => {
    const reduxContext = useContext(ReactReduxContext);
    const isInRouter = useInRouterContext();

    const withRouter = useMemo(
        () =>
            isInRouter || !routes || !routes.length ? (
                <>{children}</>
            ) : (
                <>
                    <WithRouter routes={routes} routeOpts={routeOpts} />
                    {children}
                </>
            ),
        [children, isInRouter, routeOpts, routes]
    );

    return (
        <StrictMode>
            {reduxContext ? <>{withRouter}</> : <ReduxProvider store={store}>{withRouter}</ReduxProvider>}
        </StrictMode>
    );
};

// TODO: Remove this
/** Same as App, use App directly instead */
export const AppComponent = App;

// TODO: Remove this
export default AppComponent;
